import { useMemo } from "react";
import { useExploreInteractions } from "@/v2/entities/explore/Explore.api";
import { ExploreInteractionRow } from "@/v2/entities/explore/Explore.model";
import { Filter } from "@/v2/entities/explore/Explore.filter";
import { useExploreEnrichments } from "@/v2/features/explore/useExploreEnrichments";
import { SimulatorWrapper } from "@/routes/simulators/wrapper";
import { ConversationView } from "@/v2/features/interaction-view/ConversationView";

function TrackerItemConversationView({
  conversationId,
  onClose,
}: {
  conversationId: string;
  onClose: () => void;
}) {
  const enrichments = useExploreEnrichments();
  // Create a filter to get the specific ticket by ID
  const filter: Filter = useMemo(
    () => ({
      and: [{ id: { eq: conversationId } }],
    }),
    [conversationId]
  );

  // Get ticket data using useExploreTickets
  const {
    data: conversationsData,
    isLoading,
    error,
  } = useExploreInteractions({
    source: "conversations",
    sorting: [],
    filter,
    enabled: true,
  });

  // Extract the conversation from the response
  const conversation = useMemo<ExploreInteractionRow | undefined>(() => {
    if (!conversationsData) {
      return;
    }

    return conversationsData.length > 0 ? conversationsData[0] : undefined;
  }, [conversationsData]);

  if (isLoading || conversation == null || error) {
    return <></>;
  }

  return (
    <SimulatorWrapper>
      <ConversationView
        conversation={conversation}
        enrichments={enrichments}
        onClose={onClose}
      />
    </SimulatorWrapper>
  );
}

export default TrackerItemConversationView;
